import React from 'react';
import firstCardImg from '../../../../images/1stCard.jpg';
import secondCardImg from '../../../../images/2ndCard.jpg'
import thirdCardImg from '../../../../images/3rdCard.jpg'
import ProjectCard from '../ProjectCard/ProjectCard';

const cardsDetails = [
    {
        img: firstCardImg,
        title: 'Identification of Power Theft',
        text: 'This project identifies the power theft & intimates to the board via the power line.'
    },
    {
        img: secondCardImg,
        title: 'Detection of Over Speed Automatically',
        text: ' It operates from the distance of 100m to identify the over speed of vehicles on the road'
    },
    {
        img: thirdCardImg,
        title: 'Automatic Solar Tracker',
        text: 'The automatic solar tracker begins to follow the SUN exactly from sunrise all through the day'
    }
]

const ProjectsMain = () => {
    return (
        <div id="projects">
            <div className="text-center text-color">
                <p className="mt-5">Projects</p>
                <h2><b>Discover Projects created by <br/> our company</b></h2>
            </div>
            <div className="d-flex justify-content-center row mt-5 mb-5">
                {
                    cardsDetails.map(detail => <ProjectCard detail={detail}/>)
                }
            </div>
        </div>
    );
};

export default ProjectsMain;